/** Opportunity score chip — the colour scale is inverted from audit scores,
 *  because here a HIGH number is a good thing for us. */
export function OpportunityBadge({ score }: { score: number }) {
  const tone =
    score >= 80
      ? 'bg-poor/10 text-poor'      // hot: they need us badly
      : score >= 55
        ? 'bg-average/15 text-amber-700'
        : 'bg-good/10 text-good';    // healthy site: skip

  const label = score >= 80 ? 'Hot' : score >= 55 ? 'Warm' : 'Cold';

  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-bold ${tone}`}>
      {score}
      <span className="text-[10px] font-semibold uppercase tracking-wide opacity-70">{label}</span>
    </span>
  );
}
